var _title;
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Close = function Close(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1 * size,
    height: size,
    viewBox: "0 0 32 32",
    children: [_title || (_title = /*#__PURE__*/_jsx("title", {})), /*#__PURE__*/_jsx("path", {
      fill: !ignoreColor ? color : undefined,
      d: "M31.9 6l-5.95-6-10 10-9.95-10-6 6 10 10-10 10 6 6 9.95-10 10 10 5.95-6-9.95-10z"
    })]
  });
};
export default Close;